// icons
import { MdViewKanban } from "react-icons/md";

const kanbanBoard = {
  id: 'kanban-board-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'kanban-board',
      title: 'Kanban de equipo',
      type: 'item',
      breadcrumbs: false,
      icon: MdViewKanban,
      url: '/kanban-board'
    }
  ]
};

export default kanbanBoard;
